<template>
  <div>
    <strong>Payment status:</strong>&nbsp;
    <icon :icon="['fad', 'hourglass-start']" class="" v-if="status === 'not_paid'"/>
    <icon :icon="['fad', 'hourglass-half']" class="" v-else-if="status === 'paid_process'"/>
    <icon :icon="['fad', 'check']" class="" v-else-if="status === 'paid'"/>
    {{ status }}
    <button class="btn btn-sm btn-primary" v-on:click="refreshPayment()" :disabled="pausedFor5Seconds">
      <icon :icon="['fad', 'sync']" class=""/>&nbsp;Refresh
    </button>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  props: ['abstract_id'],
  name: "payment_status",
  created() {
    this.refreshPayment();
  },
  data() {
    return {
      pausedFor5Seconds: false,
      status: 'unknown',
    }
  },
  computed: {
    ...mapState([
      'abstract'
    ]),
  },
  methods: {
    ...mapActions('payment', ['GET_PAYMENT_STATUS']),
    async refreshPayment() {
      this.pause();
      await this.GET_PAYMENT_STATUS(this.abstract_id).then((result) => {
        this.status = result.data;
        if (this.status === 'paid') {
          this.abstract.paid = true;
          this.$emit('abstract_paid');
        }
      }).catch((error) => {
        this.status = 'not_paid';
      });
    },
    pause() {
      this.pausedFor5Seconds = true;
      setTimeout(() => this.pausedFor5Seconds = false, 5000);
    }
  }
}
</script>

<style scoped>

</style>
